import React from 'react';

const Header = () => (
  <div id="Header">
    <h1>React Router demo</h1>
  </div>
);

export default Header;
